import React from 'react'
import { usePageView } from '@fs/zion-analytics'
import { useTranslation } from 'react-i18next'
import { usePageTitle } from '../../app/PageTitleContext'
import { DeleteOsrContextProvider } from './deleteOsr/DeleteOsrContext'
import PersonOrdinances from './PersonOrdinances'

export default function PersonOrdinancesBase() {
  usePageView({ page_detail: 'DMConsole:PersonOrdinancesBase' })
  const { t } = useTranslation()
  usePageTitle(t('pageTitle.person.ordinances'))
  return (
    <DeleteOsrContextProvider>
      <PersonOrdinances />
    </DeleteOsrContextProvider>
  )
}
